import useAxios from 'axios-hooks';
import {
  APP_NAME,
  WIDTH_SIDEBAR_COLLAPSE,
  WIDTH_SIDEBAR_EXPAND,
} from 'constant';
import { menuConfig, router } from 'constant/router';
import { Tooltip } from 'devextreme-react/tooltip';
import useDictionary from 'hooks/useDictionary';
import { avatarUserDefault, logOut, logo } from 'images';
import { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import tokenService from 'services/auth.service';
import { authenInfoAtom } from 'store/atom-state/authen-atom';
import { LayoutContext } from '../Layout';
import LoadPanel from '../LoadPanel';
import './styles.scss';
import { breadcrumbHeader } from 'store/atom-state/breadcrumb-header';

const classes: any = {
  sidebar: {
    width: WIDTH_SIDEBAR_EXPAND,
  },
  sidebarCollapse: {
    width: WIDTH_SIDEBAR_COLLAPSE,
  },
  sidebarPremium: {
    width: 256,
    // backgroundImage: `url(${navigationImage})`,
  },
};

const NavigationContext = createContext({});

NavigationContext.displayName = 'NavigationContext';

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  return context;
};

function Navigation() {
  const { t } = useDictionary({});
  const history = useHistory();
  const layOutContext: any = useContext(LayoutContext);
  const { collapse, toggleSidebar } = layOutContext;
  const [authenInfo, setAuthenInfo] = useRecoilState(authenInfoAtom);
  const setBreadcrumbData = useSetRecoilState(breadcrumbHeader);
  const [tooltipExpandVisible, setTooltipExpandVisible] = useState(false);
  const [subMenuSeleted, setSubMenuSeleted] = useState({
    selected: '',
    parentId: '',
  });
  const userTp: any = authenInfo?.currentUser?.userTp;

  const [{ loading }, fetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  // Toogle expand tooltip
  const toggleExpandTooltip = () => {
    setTooltipExpandVisible(!tooltipExpandVisible);
  };

  const value: any = {
    subMenuSeleted,
    setSubMenuSeleted,
  };

  const onLogout = async () => {
    await fetchData({
      url: '/oauth/logout',
      method: 'GET',
    });
    history.push(router.login);
    tokenService.removeToken();
    sessionStorage.clear();
    setAuthenInfo({
      isLoggedIn: false,
      currentUser: {},
      messageLogin: '',
    });
  };

  const onClickMenu = value => {
    history.push(value?.router);
    setBreadcrumbData(prev => {
      const prevCopy = { ...prev };
      if (prev?.root?.router === value?.router) {
        return { ...prevCopy, data: [] };
      }
      let newBread;
      const indexBread = prevCopy?.data?.findIndex(
        o => o.router === value?.router,
      );
      if (indexBread != -1) {
        newBread = prevCopy?.data?.slice(0, indexBread + 1);
      } else {
        newBread = [{ router: value?.router, label: value?.label }];
      }
      return { ...prevCopy, data: newBread };
    });
  };

  return (
    <NavigationContext.Provider value={value}>
      <LoadPanel visible={loading} />
      <div
        className="sidebar sidebar-premium menu-left-main"
        style={Object.assign(
          {},
          classes.sidebar,
          classes.sidebarPremium,
          layOutContext.collapse && classes.sidebarCollapse,
        )}
      >
        <div className="backgound-premium">
          <div
            className={`sidebar-brand ${
              layOutContext.collapse && 'sidebar-brand-collapse'
            }`}
          >
            {!layOutContext.collapse && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                  }}
                >
                  <img
                    height={30}
                    width={30}
                    src={avatarUserDefault}
                    alt="setting"
                  />
                </div>

                <div>
                  <div style={{ fontSize: 14, color: '#fff' }}>
                    {authenInfo?.currentUser?.userNm}
                  </div>
                </div>
              </div>
            )}
            <button
              onClick={toggleSidebar}
              className="btn btn-sidebar"
              id="expandBtn"
              onMouseEnter={toggleExpandTooltip}
              onMouseLeave={toggleExpandTooltip}
            >
              <i className="fas fa-bars" />
              <Tooltip
                target="#expandBtn"
                position="right"
                visible={tooltipExpandVisible && layOutContext.collapse}
              >
                <div>{t('Expand')}</div>
              </Tooltip>
            </button>
          </div>
          <div className="menu-container">
            {Object.entries(menuConfig)
              .filter(
                ([key, value]) => !value?.role || value?.role?.includes(userTp),
              )
              .map(([key, value]) => (
                <div
                  key={key}
                  className={`nav-link-core ${
                    collapse && 'nav-link-core-collapse'
                  }`}
                  onClick={() => onClickMenu(value)}
                >
                  <div
                    style={classes.navLinkText}
                    className="custom-color-white menu-item"
                  >
                    <img
                      style={Object.assign({}, classes.icon, {
                        width: 20,
                        height: 20,
                      })}
                      src={value?.icon}
                      alt="icon"
                      id={`expand_${key}`}
                    />
                    {!collapse && (
                      <span style={classes.name} className="menu-label">
                        {t(value?.label)}
                      </span>
                    )}
                    <Tooltip
                      target={`expand_${key}`}
                      position="right"
                      visible={collapse}
                    >
                      <div>{t(value?.label)}</div>
                    </Tooltip>
                  </div>
                </div>
              ))}
            {/* logout */}
            <div
              className={`nav-link-core ${
                collapse && 'nav-link-core-collapse'
              } logout`}
              onClick={onLogout}
            >
              <div
                style={classes.navLinkText}
                className="custom-color-white menu-item"
              >
                <img
                  style={Object.assign({}, classes.icon, {
                    width: 20,
                    height: 20,
                  })}
                  src={logOut}
                  alt="icon"
                />
                {!collapse && (
                  <span style={classes.name} className="menu-label">
                    {t('Logout')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="menu-footer">
            <div className="logo">
              <img src={logo} alt={APP_NAME} width={32} />
              {!collapse && <div>{APP_NAME}</div>}
            </div>
          </div>
        </div>
      </div>
    </NavigationContext.Provider>
  );
}

export default Navigation;
